import React, { ReactNode } from 'react';

import './LabelValueStatistics.scss';

interface Props {
  label: string;
  value: string | ReactNode;
}

export const LabelValueStatistics: React.FC<Props> = ({ label, value }) => {
  return (
    <div className="label-value-statistics">
      <div className="label-value-statistics__label">{label}</div>
      <div className="label-value-statistics__value">{value}</div>
    </div>
  );
};
